import { render, staticRenderFns } from "./WebhookModal.vue?vue&type=template&id=28842901&"
import script from "./WebhookModal.vue?vue&type=script&lang=js&"
export * from "./WebhookModal.vue?vue&type=script&lang=js&"
import style0 from "./WebhookModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports